colorsDirectiveModule = angular.module('colors.setting', [])

colorsDirectiveModule.directive "colorsSetting", ["$window", "$timeout", "$compile", "$templateCache", ($window, $timeout, $compile, $templateCache) ->
  restrict: "A",
  scope: {data: "=ngModel", afterChange: '&'},
  templateUrl: "#{settingFolder}/colors/template.jade"
  link: (scope, element, attrs, ngModel) ->

    scope.colors = [
      {
        color: "rgba(74, 144, 226, 1)"
      }
      {
        color:"rgba(27, 165, 66, 1)"
      }
      {
        color:"rgba(208, 2, 27, 1)"
      }
      {
        color:"rgba(144, 19, 254, 1)"
      }
      {
        color:"rgba(189, 1, 175, 1)"
      }
      {
        color:"rgba(248, 231, 28, 1)"
      }
      {
        color:"rgba(0, 0, 0, 1)"
      }
      {
        color:"rgba(155, 155, 155, 1)"
      }
      {
        color:"rgba(255, 255, 255, 1)"
      }
      {
        color:"rgba(245, 166, 35, 1)"
      }

    ]


    scope.setColor = (color) ->
      if color.color in ["rgba(248, 231, 28, 1)", "rgba(255, 255, 255, 1)"]
        scope.data.color = "rgba(0, 0, 0, 1)"
      else
        scope.data.color = "rgba(255, 255, 255, 1)"

      if attrs.setAttributes
        attributesForSet = attrs.setAttributes.split " "
        _.each attributesForSet, (attribute) ->
          scope.data[attribute] = color.color
      for c in scope.colors
        c.active = false
      color.active = true

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/colors/colors.directive.coffee